import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";

export const shouldUseTableComparison = (
  productBackendName: ProductBackendName,
): boolean => productBackendName === ProductBackendName.CAR;
